import React from 'react';
import Navbar from '../components/Navbar';
import FeedbackForm from '../components/FeedbackForm';
import Footer from '../components/Footer';

const FeedbackPage: React.FC = () => {
  return (
    <>
      <Navbar />
      <div style={{ paddingTop: '80px' }}>
        <FeedbackForm />
      </div>
      <Footer />
    </>
  );
};

export default FeedbackPage;
